export default {
      id: "video-event_daydreaming-usage",
      viewBox: "0 0 52 45",
      url: __webpack_public_path__ + "img/icons.svg#video-event_daydreaming",
      toString: function () {
        return this.url;
      }
    }